import { FunctionComponent } from 'react'

import { Box } from '@theme-ui/components'

import styled from 'styled-components'

import { Text, baseColors } from '@fairhq/common'

const StyledText = styled(Text)<{ percentage: string }>`
  line-height: 1.5rem;
  padding-left: ${({ percentage }) => percentage};
  margin-left: 8px;
`

interface ComparisonSquareBarProps {
  percentage: number
  color?: string
  borderColor?: string
}

export const ComparisonSquareBar: FunctionComponent<
  ComparisonSquareBarProps
> = ({ percentage, color, borderColor }) => {
  const percentageString = `${Math.round(percentage)}%`

  return (
    <Box
      sx={{
        position: 'relative',
        height: '24px',
        bg: 'transparent',
        width: '100%',
        maxWidth: '240px',
        borderRadius: '0 4px 4px 0',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          height: '100%',
          bg: color ?? baseColors.boldActionPrimary,
          border: '1px solid',
          borderColor: borderColor ?? baseColors.borderPrimary,
          borderLeft: 'none',
          width: percentageString,
          textAlign: 'right',
          borderRadius: '0 4px 4px 0',
        }}
      />
      <StyledText
        element="p"
        type="body"
        size="2xs"
        fontWeight={600}
        color={color ? baseColors.grey400 : baseColors.purple800}
        percentage={percentageString}
      >
        {percentageString}
      </StyledText>
    </Box>
  )
}
